// extracted by mini-css-extract-plugin
export default {"pageContainer":"AboutPage_pageContainer__MLL4l"};